import { Injectable } from '@angular/core'
import { formatDate } from '@angular/common'
import { ngxCsv } from 'ngx-csv'
import { ICsv, ICsvColumn } from '../../../models/interface/csv.interface'
import { CxDatePipe, TranslationService } from '@spartacus/core'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { CustomTableColumnType } from '../../../features/shared/custom-components/custom-table/modals/enum/custom-table.enum'

@Injectable({
  providedIn: 'root'
})
export class CsvService {
  private options = {
    title: 'CSV',
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    useBom: true,
    headers: null
  }

  constructor(
    private translation: TranslationService,
    private cxDatePipe: CxDatePipe
  ) {}

  public generateCSV(csv: ICsv): void {
    this.getFinalColumns(csv.columns).subscribe((finalColumns) => {
      const { finalData, finalHeaders } = this.getCsvData(finalColumns, csv.rows)
      this.options.showTitle = !!csv.header
      this.options.headers = finalHeaders.map((item) => item.title)
      this.options.title = csv.header

      const todayDate = formatDate(new Date(), 'yyyy/MM/dd', 'en')
      const fileName = csv.title + '_' + todayDate
      new ngxCsv(finalData, fileName, this.options)
    })
  }

  private getFinalColumns(columns: ICsvColumn[]): Observable<ICsvColumn[]> {
    const newTitles = columns.map((item) => this.translation.translate(item.title))
    return combineLatest(newTitles).pipe(
      map((titles) => {
        return columns.map((item, i) => {
          const newColumn = { ...item }
          newColumn.title = titles[i].replace(/ /g, '_')
          return newColumn
        })
      })
    )
  }

  private getCsvData(columns: ICsvColumn[], rows: any[]): any {
    const finalHeaders = columns.map((item) => {
      return { title: item.title.replace(/_/g, ' '), type: item.type, value: item.value }
    })
    const finalKeys = columns.map((item) => this.getKeysFromKey(item.key))
    const finalData = rows.map((itemRow) => {
      return finalHeaders.reduce((acc, key, i) => {
        if (key.value) {
          acc[key.title] = this.formatValue(key.value, key.type)
        } else {
          const value = this.getValue(itemRow, finalKeys[i], 0) || ''
          acc[key.title] = this.formatValue(value, key.type)
        }
        return acc
      }, {})
    })

    return { finalData, finalHeaders }
  }

  private getValue(obj: any, keys: string[], keyIndex: number): any {
    const key = keys[keyIndex]
    if (keys.length - 1 > keyIndex) {
      const nextKeyIndex = keyIndex + 1
      const nextLevel = obj[key]
      if (!nextLevel) {
        return null
      }
      return this.getValue(nextLevel, keys, nextKeyIndex)
    }
    return obj[key] || null
  }

  private getKeysFromKey(key: string): string[] {
    return key ? key.split('.') : []
  }

  private formatValue(value: any, type: string): any {
    if (!value) {
      return value
    }

    switch (type) {
      case CustomTableColumnType.DATE:
        return this.cxDatePipe.transform(value, 'longDate')

      default:
        return value
    }
  }

  public extractEntries(results, field: string): any[] {
    let newItems: any[] = results.map((item) => {
      if (item[field].length) {
        return item[field].map((entry) => {
          return {
            ...item,
            entry: { ...entry }
          }
        })
      }
      return item
    })
    newItems = newItems.reduce((acc, item) => {
      return acc.concat(item)
    }, [])
    return newItems
  }
}
